module.exports = __webpack_public_path__ + "img/find-location.d564300f.svg";